(function () {
  if (window.__destiniPLPInit) return;
  window.__destiniPLPInit = true;

  var host = null;
  var obs = null;
  var resizeTimer = null;
  var LAYOUT_ATTR = 'data-destini-1200-layout';

  var DESTINI_CSS =
    'button.chakra-button{background:#7DB9D8!important;color:#24145F!important;width:100%!important;min-height:52px!important;height:52px!important;padding:0.75rem 1rem!important;border:none!important;border-radius:0.5rem!important;font-family:NewSpiritCondensed,serif!important;font-size:var(--font-size-base,1rem)!important;font-weight:700!important;text-transform:uppercase!important;letter-spacing:0.05em!important;line-height:1.2!important;display:flex!important;align-items:center!important;justify-content:center!important;box-sizing:border-box!important;box-shadow:inset 0 0 0 2px #5B2412,4px 4px 0 0 #5B2412!important;cursor:pointer!important;position:relative!important;transition:transform .1s cubic-bezier(.215,.61,.355,1),box-shadow .1s cubic-bezier(.215,.61,.355,1)!important;}' +
    '@media(hover:hover) and (pointer:fine){button.chakra-button:hover{transform:translate(4px,4px)!important;box-shadow:inset 0 0 0 2px #5B2412,0 0 0 0 #5B2412!important;}}' +
    'button.chakra-button:active{transform:translate(4px,4px)!important;box-shadow:inset 0 0 0 2px #5B2412,0 0 0 0 #5B2412!important;}' +
    'input,.chakra-input{min-height:50px!important;height:50px!important;padding:8px 12px!important;line-height:1.2!important;box-sizing:border-box!important;min-width:180px!important;flex:1 1 180px!important;width:100%!important;}' +
    '.chakra-form-control{min-width:180px!important;width:100%!important;}' +
    '.chakra-input__group,[class*="input-group"],[class*="InputGroup"]{display:flex!important;align-items:center!important;flex-wrap:nowrap!important;width:100%!important;max-width:100%!important;}' +
    '.chakra-input__right-element,[class*="InputRightElement"]{flex:0 0 auto!important;width:36px!important;min-width:36px!important;padding:0!important;}' +
    'form,[class*="search-form"],[class*="SearchForm"],[class*="locator-search"]{width:100%!important;max-width:100%!important;padding-left:0!important;padding-right:0!important;}' +
    '@media(min-width:1200px){.chakra-form__label,[class*="form-label"],[class*="FormLabel"]{left:13px!important;top:4px!important;}}' +
    '@media(max-width:1199px){.chakra-form__label,[class*="form-label"],[class*="FormLabel"]{left:13px!important;top:4px!important;}.locator-template-container header{flex-direction:column!important;align-items:stretch!important;height:auto!important;min-height:0!important;padding:15px 10px!important;width:100%!important;}.locator-template-container header .chakra-stack{width:100%!important;max-width:100%!important;flex:1 1 100%!important;}.locator-template-container header .chakra-stack>.chakra-stack{flex-direction:column!important;width:100%!important;max-width:100%!important;margin:10px 0 0!important;padding-left:0!important;}[aria-label="filter"]{width:100%!important;max-width:100%!important;}}' +
    '.chakra-portal,.portal-container,.chakra-modal__overlay,.chakra-modal__content-container,.chakra-modal__content,[role="dialog"]{z-index:2147483647!important;}' +
    '@media(min-width:1200px){.chakra-modal__content-container .destini-css-1u2cvaz{top:0!important;padding-top:70px!important;overflow:visible!important;}.chakra-modal__content-container.destini-css-1u2cvaz{top:0!important;padding-top:70px!important;overflow:visible!important;}}' +
    '@media(max-width:1199px){.chakra-modal__content-container .destini-css-1u2cvaz{top:0!important;padding-top:70px!important;overflow:visible!important;}.chakra-modal__content-container.destini-css-1u2cvaz{top:0!important;padding-top:70px!important;overflow:visible!important;}}' +
    '.locator-template-container{min-height:85vh!important;padding-top:80px!important;padding-bottom:120px!important;background:#fff!important;}';

  function injectStyles(root) {
    if (!root || !root.appendChild || root.querySelector('#dplp')) return;
    var style = document.createElement('style');
    style.id = 'dplp';
    style.textContent = DESTINI_CSS;
    root.appendChild(style);
  }

  function forEachModalShadowRoot(fn) {
    var seen = new Set();

    function visitRoot(root) {
      if (!root || seen.has(root) || !root.querySelector) return;
      seen.add(root);
      if (
        root.querySelector('.locator-template-container') ||
        root.querySelector('[role="dialog"]') ||
        root.querySelector('.chakra-modal__body')
      ) {
        fn(root);
      }
    }

    function walk(node, depth) {
      if (!node || depth > 12) return;
      if (node.shadowRoot) {
        visitRoot(node.shadowRoot);
        walk(node.shadowRoot, depth + 1);
      }
      if (node.children) {
        for (var i = 0; i < node.children.length; i++) {
          walk(node.children[i], depth + 1);
        }
      }
    }

    if (host && host.shadowRoot) visitRoot(host.shadowRoot);
    if (host) walk(host, 0);
    walk(document.body, 0);
  }

  function clearResponsiveLayout(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('[' + LAYOUT_ATTR + ']').forEach(function (el) {
      ['width', 'max-width', 'flex-direction', 'align-items', 'height', 'padding', 'margin', 'padding-left'].forEach(
        function (prop) {
          el.style.removeProperty(prop);
        }
      );
      el.removeAttribute(LAYOUT_ATTR);
    });
  }

  function applyResponsiveLayout() {
    var isNarrow = window.innerWidth <= 1199;

    forEachModalShadowRoot(function (root) {
      var header = root.querySelector('.locator-template-container header');
      if (!header) return;

      if (!isNarrow) {
        clearResponsiveLayout(root);
        return;
      }

      header.style.setProperty('flex-direction', 'column', 'important');
      header.style.setProperty('align-items', 'stretch', 'important');
      header.style.setProperty('height', 'auto', 'important');
      header.style.setProperty('padding', '15px 10px', 'important');
      header.style.setProperty('width', '100%', 'important');
      header.setAttribute(LAYOUT_ATTR, '1');

      header.querySelectorAll('.chakra-stack').forEach(function (el) {
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('max-width', '100%', 'important');
        el.setAttribute(LAYOUT_ATTR, '1');
      });

      header.querySelectorAll('.chakra-stack > .chakra-stack').forEach(function (el) {
        el.style.setProperty('flex-direction', 'column', 'important');
        el.style.setProperty('width', '100%', 'important');
        el.style.setProperty('margin', '10px 0 0 0', 'important');
        el.style.setProperty('padding-left', '0', 'important');
        el.setAttribute(LAYOUT_ATTR, '1');
      });

      var filter = root.querySelector('[aria-label="filter"]');
      if (filter) {
        filter.style.setProperty('width', '100%', 'important');
        filter.style.setProperty('max-width', '100%', 'important');
        filter.setAttribute(LAYOUT_ATTR, '1');
      }
    });
  }

  function refreshDestiniUi() {
    forEachModalShadowRoot(injectStyles);
    if (host && host.shadowRoot) injectStyles(host.shadowRoot);
    applyResponsiveLayout();
  }

  function boostModalLayers() {
    if (!host || !host.shadowRoot) return;

    var selectors =
      '.chakra-modal__overlay, .chakra-modal__content-container, .chakra-portal, .portal-container, [role="dialog"]';

    function walk(root) {
      if (!root || !root.querySelectorAll) return;

      root.querySelectorAll(selectors).forEach(function (el) {
        el.style.zIndex = '2147483647';
      });

      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) walk(el.shadowRoot);
      });
    }

    walk(document);
    document.body.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) walk(el.shadowRoot);
    });
    walk(host.shadowRoot);
  }

  function attachObs() {
    if (!host || !host.shadowRoot || obs) return;

    obs = new MutationObserver(function () {
      var open = !!(
        host.shadowRoot.querySelector('[role="dialog"]') ||
        host.shadowRoot.querySelector('.chakra-modal__overlay') ||
        host.shadowRoot.querySelector('.chakra-modal__content-container') ||
        host.shadowRoot.querySelector('.chakra-modal__body')
      );
      document.body.classList.toggle('destini-modal-open', open);
      if (open) {
        refreshDestiniUi();
        boostModalLayers();
        setTimeout(refreshDestiniUi, 300);
        setTimeout(refreshDestiniUi, 800);
      }
    });
    obs.observe(host.shadowRoot, { childList: true, subtree: true });
  }

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refreshDestiniUi, 150);
  });

  var DESTINI_SCRIPT_URL = 'https://lets.shop/productWidgetSnippet.js';
  var hasOpenedOnce = false;

  function preloadDestiniScript() {
    if (document.querySelector('[data-destini-preload]')) return;

    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'script';
    link.href = DESTINI_SCRIPT_URL;
    link.setAttribute('data-destini-preload', 'true');
    document.head.appendChild(link);
  }

  function loadDestiniScript(reload) {
    if (reload) {
      window.__destiniScriptReady = false;
      window.__destiniScriptPromise = null;
      document.querySelectorAll('script[src*="productWidgetSnippet.js"]').forEach(function (script) {
        script.remove();
      });
    }

    if (window.__destiniScriptReady) {
      return Promise.resolve();
    }

    if (window.__destiniScriptPromise) {
      return window.__destiniScriptPromise;
    }

    window.__destiniScriptPromise = new Promise(function (resolve) {
      var existing = document.querySelector('script[src*="productWidgetSnippet.js"]');
      if (existing) {
        if (existing.getAttribute('data-destini-loaded') === 'true') {
          window.__destiniScriptReady = true;
          resolve();
          return;
        }

        existing.addEventListener('load', function () {
          existing.setAttribute('data-destini-loaded', 'true');
          window.__destiniScriptReady = true;
          resolve();
        });
        return;
      }

      var script = document.createElement('script');
      script.charset = 'utf-8';
      script.src = DESTINI_SCRIPT_URL;
      script.onload = function () {
        script.setAttribute('data-destini-loaded', 'true');
        window.__destiniScriptReady = true;
        resolve();
      };
      script.onerror = function () {
        window.__destiniScriptPromise = null;
        resolve();
      };
      document.head.appendChild(script);
    });

    return window.__destiniScriptPromise;
  }

  function waitForDestiniButton(callback) {
    var attempts = 0;
    var maxAttempts = 80;

    (function poll() {
      var button = host.shadowRoot && host.shadowRoot.querySelector('button.chakra-button');
      if (button) {
        callback(button);
        return;
      }
      if (++attempts < maxAttempts) {
        setTimeout(poll, 150);
      }
    })();
  }

  function openDestiniModal(button) {
    button.click();
    hasOpenedOnce = true;
    refreshDestiniUi();
    setTimeout(refreshDestiniUi, 300);
    setTimeout(refreshDestiniUi, 800);
  }

  window.__destiniOpenPLP = function (upc) {
    if (!upc) return;

    var settings = window.__destiniSettings || {};
    var locatorId = settings.locatorId;
    var alphaCode = settings.alphaCode;
    if (!locatorId) return;

    var old = document.getElementById('destini-plp-host');
    if (old) old.remove();
    if (obs) {
      obs.disconnect();
      obs = null;
    }

    host = document.createElement('div');
    host.id = 'destini-plp-host';
    host.className = 'destini-locator-class';
    host.setAttribute('data-locator-id', locatorId);
    host.setAttribute('data-alpha-code', alphaCode || '');
    host.setAttribute('data-apo', upc);
    host.style.cssText =
      'position:fixed;left:-9999px;top:-9999px;width:1px;height:1px;z-index:99999;';
    document.body.appendChild(host);

    loadDestiniScript(hasOpenedOnce).then(function () {
      attachObs();

      var readyDelay = hasOpenedOnce ? 300 : 2000;
      setTimeout(function () {
        waitForDestiniButton(function (button) {
          openDestiniModal(button);
        });
      }, readyDelay);
    });
  };

  preloadDestiniScript();

  function onTrigger(e) {
    var el = e.target.closest('.destini-plp-trigger');
    if (!el) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    if (e.type === 'keydown') e.preventDefault();

    var upc = el.dataset.destiniUpc;
    if (upc) window.__destiniOpenPLP(upc);
  }

  function simulateRealClick(el) {
    var rect = el.getBoundingClientRect();
    var x = rect.left + rect.width / 2;
    var y = rect.top + rect.height / 2;
    var opts = {
      bubbles: true,
      cancelable: true,
      composed: true,
      view: window,
      clientX: x,
      clientY: y,
      button: 0,
      buttons: 1,
    };

    ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
      var Ctor = type.indexOf('pointer') === 0 ? window.PointerEvent : window.MouseEvent;
      if (!Ctor) return;
      el.dispatchEvent(new Ctor(type, opts));
    });
  }

  function getHeaderEl() {
    return (
      document.querySelector('[data-sticky-header]') ||
      document.querySelector('.shopify-section-group-header-group')
    );
  }

  function closeDestiniModal() {
    forEachModalShadowRoot(function (root) {
      var dialog = root.querySelector('[role="dialog"]');
      if (dialog) {
        ['keydown', 'keyup'].forEach(function (type) {
          dialog.dispatchEvent(
            new KeyboardEvent(type, {
              key: 'Escape',
              code: 'Escape',
              keyCode: 27,
              which: 27,
              bubbles: true,
              cancelable: true,
              composed: true,
            })
          );
        });
      }

      var closeBtn = root.querySelector('.chakra-modal__close-btn, [aria-label="Close"], [aria-label="close"]');
      if (closeBtn) {
        simulateRealClick(closeBtn);
        return;
      }

      var overlay = root.querySelector('.chakra-modal__overlay');
      if (overlay) {
        simulateRealClick(overlay);
      }
    });

    ['keydown', 'keyup'].forEach(function (type) {
      document.dispatchEvent(
        new KeyboardEvent(type, {
          key: 'Escape',
          code: 'Escape',
          keyCode: 27,
          which: 27,
          bubbles: true,
          cancelable: true,
        })
      );
    });
  }

  function isEventFromDestiniWidget(e) {
    var path = e.composedPath ? e.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node.nodeType !== 1 || !node.shadowRoot) continue;
      if (
        node.id === 'destini-plp-host' ||
        (node.id && node.id.indexOf('destini-locator-') === 0) ||
        (node.className && String(node.className).indexOf('destini-locator-class') !== -1)
      ) {
        return true;
      }
    }
    return false;
  }

  function isPointInHeader(x, y) {
    var header = getHeaderEl();
    if (!header) return false;
    var rect = header.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function onHeaderClickWhileOpen(e) {
    if (!document.body.classList.contains('destini-modal-open')) return;
    if (isEventFromDestiniWidget(e)) return;
    if (!isPointInHeader(e.clientX, e.clientY)) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    closeDestiniModal();
  }

  document.addEventListener('click', onTrigger);
  document.addEventListener('keydown', onTrigger);
  document.addEventListener('click', onHeaderClickWhileOpen, true);
})();
